export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Iniciar sesión",
    "login.form.hint.user": "Inicio de sesión",
    "login.form.hint.password": "Contraseña",
    "login.form.checkbox.remember-me": "Recordarme",
    "login.form.button.sign-in": "Iniciar sesión",
    "login.form.message.invalid-user-credentials": "El usuario o la contraseña son incorrectos",
    "login.form.message.user-required": "Introduzca el usuario",
    "login.form.message.password-required": "Introduzca la contraseña",
    "login.form.button.forgot-password": "¿Olvidó su contraseña?",
    "error.root-admin-login.title": "Error 403 - prohibido",
    "error.root-admin-login.message": "Ha iniciado sesión como administrador de solo lectura. Para acceder a la consola de Web Recovery, inicie sesión en su lugar como inquilino de cliente o administrador."
};
